export default __webpack_public_path__ + "static/media/searchIcon.547d467d.svg";